function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  className: "circle",
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  fill: "#fff",
  stroke: "#129595",
  strokeWidth: 3
}, React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  stroke: "none"
}), React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 18.5,
  fill: "none"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "x",
  id: "Union_19",
  "data-name": "Union 19",
  d: "M-1306-245.156l8,8.157Zm0,.313-8,7.843Zm-8-8.157,8,8.157Zm8,7.844,8-7.844ZM-1306-245.156Z",
  transform: "translate(1326 265)",
  fill: "none",
  stroke: "#129595",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 4
});

var SvgCloseIconCircled = function SvgCloseIconCircled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Group_95",
    "data-name": "Group 95",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCloseIconCircled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/close-icon_circled.928a4b3e.svg";
export { ForwardRef as ReactComponent };